import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class ContentText extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): ContentText {
    return new ContentText(value);
  }

  /**
   * ラベル
   */
  static get label(): string {
    return '内容';
  }

  /**
   * PlaceHolder
   */
  static get placeholder(): string {
    return '内容';
  }

  /**
   * バリデーションルール
   */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /**
   * キー
   */
  static get key(): string {
    return 'text';
  }

  /**
   * タイプ
   */
  static get type(): string {
    return 'text';
  }

  /**
   * 表示を返す
   * @returns 表示
   */
  override toString() {
    return this.value;
  }
}
